import React from "react";

export function DashboardPreviewCard({ entry, isCurrent, onSelect }) {
  const { id, label, preview } = entry;
  const theme = preview?.theme ?? "default";
  const metrics = preview?.metrics ?? [];

  const resolveMetricValue = (metric) => {
    if (metric?.dynamicKey) {
      try {
        const value = localStorage.getItem(metric.dynamicKey);
        if (value != null && String(value).trim()) {
          return value;
        }
      } catch {
        // ignore
      }
    }
    return metric?.value;
  };

  return (
    <button
      type="button"
      className={`dashboard-preview-card dashboard-preview-card--${theme}${
        isCurrent ? " dashboard-preview-card--current" : ""
      }`}
      aria-current={isCurrent ? "true" : undefined}
      aria-label={`${label}${isCurrent ? ", current dashboard" : ""}`}
      onClick={() => onSelect(id)}
    >
      <div className="dashboard-preview-card-chrome">
        <div className="dashboard-preview-card-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        {isCurrent && (
          <span className="dashboard-preview-card-badge">Current</span>
        )}
      </div>

      <div className="dashboard-preview-card-body">
        <h3 className="dashboard-preview-card-title">{label}</h3>

        <div className="dashboard-preview-card-metrics">
          {metrics.map((metric) => (
            <div key={metric.label} className="dashboard-preview-card-metric">
              <span className="dashboard-preview-card-metric-label">
                {metric.label}
              </span>
              <span
                className={`dashboard-preview-card-metric-value${
                  metric.variant === "active"
                    ? " dashboard-preview-card-metric-value--active"
                    : ""
                }`}
              >
                {metric.variant === "active" && (
                  <span
                    className="dashboard-preview-card-metric-dot"
                    aria-hidden="true"
                  />
                )}
                {resolveMetricValue(metric)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </button>
  );
}
